import { ButtonContainer } from 'features/verify/ui/button-container';
import { OnboardLayout } from 'features/verify/ui/onboard-layout';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { Photo } from 'model/domain';
import { sendEvent } from 'model/helpers/events.model';
import { uploadPhotoFx } from 'model/flows/verification.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { version } from '../../../../../package.json';

import { Button } from 'ui/atoms/button';
import { InfoIcon } from 'ui/icons/info-icon';
import { InputCapture } from 'ui/input/input-capture';

export const DocumentFront = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	useEffect(() => {
		screenHistoryPush(ScreenName.doc_front_instructions);
		setTimeout(() => sendEvent({ event: 'doc_front_instructions_screen_shown' }), 20);
	}, []);
	const handleUpload = async (photo: Photo) => {
		const t0 = performance.now();
		await uploadPhotoFx({ photo });
		const upload_time = Math.round(performance.now() - t0);
		sendEvent({
			event: 'doc_front_upload_success',
			event_attributes: { upload_time },
		});
	};
	const handleContinue = () => {
		sendEvent({
			event: 'doc_front_instructions_screen_continue',
			event_attributes: {
				duration: Date.now() - start,
			},
		});
	};

	return (
		<OnboardLayout
			title={t('mobile.doc.front.title')}
			subtitle={t('mobile.doc.front.subtitle')}
			info={[{
				icon: <InfoIcon
					fill={'var(--text-tertiary)'}
				/>,
				text: <Fragment>
					{t('mobile.doc.front.instructions')}
				</Fragment>,
			}]}
		>
			<ButtonContainer>
				<ImageContainer>
					<img src={`https://cdn.hive.id/verify-js/${version}/images/doc_front.svg`} alt=""/>
				</ImageContainer>
				<InputCapture
					className={fluidClass}
					cameraType={'back'}
					onCapture={handleUpload}
				>
					<Button
						onClick={handleContinue}
						className={fluidClass}
						name={'mobile.doc.front.btn'}
					>
						{t('mobile.doc.front.btn')}
					</Button>
				</InputCapture>
			</ButtonContainer>
		</OnboardLayout>
	);
};

const fluidClass = css`
	width: 100%;
`;
const ImageContainer = styled('div')`
	margin: 16px auto auto;

  @media (max-height: 500px) {
    display: none;
  }
`;
